import {
  SetDimensions as SegmentSetDimensions,
  Initialize as SegmentInitialize,
  PageView as SegmentPageView,
  TrackEvent as SegmentTrackEvent,
  Group as SegmentGroup,
} from 'utils/SegmentAnalytics'

import getConfig from 'next/config'

const { publicRuntimeConfig } = getConfig()

export const SetDimensions = (metadata) => {
  if (typeof window === 'undefined') {
    return
  }

  SegmentSetDimensions(metadata)
}

export const InitializeAnalytics = (domain, pageType) => {
  if (typeof window === 'undefined') {
    return
  }

  if (window.analytics_initialized) {
    return
  }
  window.analytics_initialized = true

  SegmentInitialize(domain)
  const { CGC_WEB_RELEASE_ID } = publicRuntimeConfig
  const metadata = {
    appVersion: CGC_WEB_RELEASE_ID,
    dimension1: pageType,
    dimension3: domain,
  }
  SetDimensions(metadata)
}

export const CurrentPath = () => {
  return window.location.pathname + window.location.search
}

export const PageView = (url, metadata = null, router) => {
  if (typeof window === 'undefined') {
    return
  }

  if (!url) {
    url = CurrentPath()
  }
  if (router && router.query) {
    metadata = {
      ...metadata,
      ...router.query,
    }
  }

  const pageName = metadata && metadata.page_type
  SegmentPageView(pageName)
}

export const TrackEvent = (eventName, metadata = {}) => {
  if (typeof window === 'undefined' || !eventName) {
    return
  }
  SegmentTrackEvent(eventName, metadata)
}

export const Group = (id, metadata) => {
  if (typeof window === 'undefined') {
    return
  }

  SegmentGroup(id, metadata)
}
